import { Form, Button } from "antd";

import React from "react";
import "./style.css";

const UiButton = (props) => {
  const { onClick, title, tabIndex, type, disabled, aligned, style, onSubmit } =
    props;
  const FormItem = Form.Item;
  return (
    <Button
      style={style}
      tabIndex={tabIndex}
      htmlType={type === "submit" ? "submit" : "button"}
      className={
        type === "submit" || type === "primary"
          ? "submit-primary-btn"
          : "reset-btn"
      }
      onClick={onClick}
      onSubmit={onSubmit}
      disabled={disabled}
    >
      {title}
    </Button>
  );
};

export default UiButton;
